// スクリーニング(セグメント) 事業セグメント表示内容保存
export const RESULT_DATA_SET =
  "tools/screening/segment/business/result-data/RESULT_DATA_SET";
// スクリーニング(セグメント) 事業セグメント表示内容クリア
export const RESULT_DATA_CLEAR =
  "tools/screening/segment/business/result-data/RESULT_DATA_CLEAR";
